// extracted by mini-css-extract-plugin
module.exports = {"message":"jgp-22FJa"};